import React, { Component } from 'react';
import classNames from 'classnames';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

import EpisodesSearch from './EpisodesSearch';
import SubscribeLinks, {
  SubscribeLinksPlacement,
} from '../../../../components/ui/SubscribeLinks';

import {
  isShowHeaderEnabled,
  isGridLayoutSelected,
} from '../../../../selectors/settings';

import { IWithSettingsProps } from '../../../../components/context/settings';
import { IWithTPAProps } from '../../../../components/context/tpa';

import styles from './Episodes.scss';

interface IEpisodesToolbarProps extends IWithSettingsProps, IWithTPAProps {
  searchQuery: string;
  onSearchChange(query: string): void;
}

interface IEpisodesToolbarState {
  searchFocused: boolean;
}

class EpisodesToolbar extends Component<
  IEpisodesToolbarProps,
  IEpisodesToolbarState
> {
  state = {
    searchFocused: false,
  };

  handleFocus = () => this.setState({ searchFocused: true });
  handleBlur = () => this.setState({ searchFocused: false });

  render() {
    const { settings, tpa, onSearchChange, searchQuery } = this.props;

    const isGridLayout = isGridLayoutSelected(settings, tpa.params.deviceType);

    const isHeaderShown = isShowHeaderEnabled(settings);

    const showSubscribeLinks = !isHeaderShown;

    const isMobile = tpa.params.deviceType === TPADeviceType.MOBILE;
    const isSearchEmpty = !searchQuery;
    const showSearchInput = this.state.searchFocused || !isSearchEmpty;

    return (
      <div
        className={classNames(
          { [styles.gridToolbar]: isGridLayout },
          styles.toolbar,
        )}
      >
        <EpisodesSearch
          query={searchQuery}
          onSearch={onSearchChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          minimized={isMobile && showSubscribeLinks && !showSearchInput}
          autoFocus={isMobile && showSubscribeLinks}
        />
        {showSubscribeLinks && (!isMobile || !showSearchInput) && (
          <SubscribeLinks placement={SubscribeLinksPlacement.Feed} />
        )}
      </div>
    );
  }
}

export default EpisodesToolbar;
